import axios from 'axios';

// In production (Vercel), API is at same domain. In development, use localhost:8000
const BACKEND_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000');
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const projectsAPI = {
  getAll: (params = {}) => axios.get(`${API}/projects`, { params }),
  getOne: (id) => axios.get(`${API}/projects/${id}`),
  create: (data) => axios.post(`${API}/admin/projects`, data, { headers: getAuthHeaders() }),
  update: (id, data) => axios.put(`${API}/admin/projects/${id}`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/admin/projects/${id}`, { headers: getAuthHeaders() })
};

export const categoriesAPI = {
  getAll: () => axios.get(`${API}/categories`),
  create: (data) => axios.post(`${API}/admin/categories`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/admin/categories/${id}`, { headers: getAuthHeaders() })
};

export const aboutAPI = {
  get: () => axios.get(`${API}/about`),
  update: (data) => axios.put(`${API}/admin/about`, data, { headers: getAuthHeaders() })
};

export const contactAPI = {
  get: () => axios.get(`${API}/contact`),
  update: (data) => axios.put(`${API}/admin/contact`, data, { headers: getAuthHeaders() }),
  submit: (data) => axios.post(`${API}/contact/submit`, data)
};

export const adminAPI = {
  getStats: () => axios.get(`${API}/admin/stats`, { headers: getAuthHeaders() }),
  uploadImage: (data) => axios.post(`${API}/admin/upload`, data, { headers: getAuthHeaders() })
};

export const messagesAPI = {
  getAll: () => axios.get(`${API}/admin/contact-submissions`, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/admin/contact-submissions/${id}`, { headers: getAuthHeaders() })
};

export const analyticsAPI = {
  trackPageView: (data) => axios.post(`${API}/analytics/page-view`, data),
  getPageViews: () => axios.get(`${API}/admin/analytics/page-views`, { headers: getAuthHeaders() }),
  getStats: () => axios.get(`${API}/admin/analytics/stats`, { headers: getAuthHeaders() })
};
